import { get, post } from "../helpers/api_helper"

const INQUIRY_BASE_URL = "/inquiries"

export const getInquiriesService = () => get(INQUIRY_BASE_URL)
export const createInquiryService = (payload) => post(INQUIRY_BASE_URL, payload)